import { render, staticRenderFns } from "./AlarmMain.vue?vue&type=template&id=3f898609&scoped=true"
import script from "./AlarmMain.vue?vue&type=script&lang=js"
export * from "./AlarmMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f898609",
  null
  
)

export default component.exports